import { type InsuranceCorporateIdentity } from "../types";

export function KKHLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M441.781 182C431.712 182 423.562 190.177 423.562 200.279V242.422H377.438V200.279C377.438 190.177 369.288 182 359.219 182C349.15 182 341 190.177 341 200.279V311.721C341 321.823 349.15 330 359.219 330C369.288 330 377.438 321.823 377.438 311.721V273.43H423.562V311.721C423.562 321.823 431.712 330 441.781 330C451.85 330 460 321.823 460 311.721V200.279C460 190.177 451.85 182 441.781 182ZM165.32 209.685L126.905 258.299L164.39 302.918C170.46 310.154 169.53 320.93 162.285 326.992C155.039 333.072 144.249 332.126 138.179 324.89L95.1945 273.727H87.6329V312.046C87.6329 322.156 79.4396 330.339 69.3164 330.339C59.1933 330.339 51 322.156 51 312.046V200.522C51 190.412 59.1933 182.229 69.3164 182.229C79.4396 182.229 87.6329 190.429 87.6329 200.522V242.696H95.6332L138.459 188.502C144.319 181.09 155.074 179.829 162.495 185.681C169.899 191.533 171.18 202.274 165.32 209.685ZM271.261 258.299L309.351 209.685C315.161 202.274 313.891 191.533 306.55 185.681C299.192 179.829 288.528 181.09 282.718 188.502L240.255 242.696H232.322V200.522C232.322 190.429 224.199 182.229 214.161 182.229C204.124 182.229 196 190.412 196 200.522V312.046C196 322.156 204.124 330.339 214.161 330.339C224.199 330.339 232.322 322.156 232.322 312.046V273.727H239.82L282.44 324.89C288.459 332.126 299.157 333.072 306.342 326.992C313.526 320.93 314.448 310.154 308.429 302.918L271.261 258.299Z"
        fill="#0A1E49"
      />
    </svg>
  );
}

export const KKH: InsuranceCorporateIdentity = {
  id: "kkh",
  name: "KKH Kaufmännische Krankenkasse",
  logo: KKHLogo,
  backgroundColor: "#FFA090",
  textColor: "#FFFFFF",
  wildcard: "kkh",
  type: "statutory",
};
